import React from 'react';
import { useAudience } from '../context/AudienceContext';
import Services from './Services';
import ROIReporting from './ROIReporting';

const AudienceBasedSections = ({ onROICalculatorClick }) => {
  const { isB2B } = useAudience();

  // Only show Services and ROI Reporting sections for B2B/Corporate users
  if (!isB2B) {
    return null;
  }

  return (
    <>
      <Services />
      <ROIReporting onROICalculatorClick={onROICalculatorClick} />
    </>
  );
};

export default AudienceBasedSections;
